import { useGlobal } from "@vojomo-core/shared";
import "./LearnLayout.css";

export const LearnLayout = ({
  children,
  videoUrl
}: {
  children: React.ReactNode;
  videoUrl?: string;
}) => {
  const { isMobile } = useGlobal();

  return (
    <div
      style={{
        color: "#2B1460",
        marginLeft: isMobile ? "0px" : "50px",
        padding: isMobile ? "16px" : "0px",
        maxWidth: isMobile ? "100%" : "none"
      }}
    >
      {videoUrl && (
        <div
          style={{
            position: "relative",
            width: isMobile ? "100%" : "550px",
            paddingBottom: isMobile ? "56.25%" : "0", // 16:9 aspect ratio for mobile
            height: isMobile ? "0" : "310px",
            marginTop: isMobile ? "16px" : "50px",
            overflow: "hidden"
          }}
        >
          <iframe
            style={{
              position: isMobile ? "absolute" : "static",
              top: 0,
              left: 0,
              width: "100%",
              height: isMobile ? "100%" : "310px",
              border: "none"
            }}
            src={videoUrl}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
      )}
      <br />
      <div className="learn-content">{children}</div>
      <br />
      <br />
    </div>
  );
};
